// extracted by mini-css-extract-plugin
module.exports = {"tipWrapper":"styles_tipWrapper__v5Ys_","tipWrapperInline":"styles_tipWrapperInline__JlwaY"};